import { Api } from '@shared/api/Api';

export class AssignSecurity {
    private static _basePath = '/AssignedSecurity';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${AssignSecurity._basePath}`;
        return {
            async postAssignSecurity(body: any) {
                const path = '/assignSecurities';
                return await Api.post<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },

            async postAssignBulkSecurity(body: any) {
                const path = '/assignBulkSecurities';
                return await Api.post<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
        };
    }
}
